"use client";

import { useEnvContext } from "next-runtime-env";
import { useEffect } from "react";

import * as track from "../../tracking/cmsPage.tracking";

type InitProps = {
  title: string;
};

export const Init = ({ title }: InitProps) => {
  const { NEXT_PUBLIC_COUNTRY } = useEnvContext();

  useEffect(() => {
    track.storeCountry(NEXT_PUBLIC_COUNTRY?.toLowerCase() || "");
    track.deviceUUID();
    track.pageView({ title });
  }, [title, NEXT_PUBLIC_COUNTRY]);

  return null;
};
